/* eslint-disable no-empty */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { useCourseStore } from '../../../courseStore';

interface ITopicContainerProps {
  className?: string;
}

const TopicContainer: React.FunctionComponent<ITopicContainerProps> = (
  props
) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState, setParagraphState, courses } = useStore();
  const { setActiveParagraph } = useCourseStore();

  const course = courses[p_course];
  const currentTopic = course.topics.find(
    (itm: { id: string }) => itm.id === p_topic
  );
  const debounce = (func: any, delay: any) => {
    let timer: any = null;
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        func.apply(this, arguments);
        timer = null;
      }, delay);
    };
  };
  React.useEffect(() => {
    const onScroll = () => {
      console.log('scroll in the Container');
      const scrolltop = document?.querySelector('.course-body')?.scrollTop || 0;
      const m_paragraphs: any[] = [];
      let start = 0;
      document.querySelectorAll('[data-paragraph]').forEach((element: any) => {
        m_paragraphs.push({
          id: element.dataset.paragraph,
          height: element.offsetHeight,
          start,
          end: start + element.offsetHeight,
        });
        start = start + element.offsetHeight;
      });
      const maxHeightOfParagraph = m_paragraphs[m_paragraphs.length - 1]?.end;
      const courseBodyHeight =
        document.querySelector<HTMLElement>('.course-body')?.offsetHeight || 0;
      const paragraphs = getParagraphState(p_course, p_topic);
      if (
        !currentTopic.paragraphs[currentTopic.paragraphs.length - 1]
          .isRequired &&
        !document.querySelector<HTMLElement>('.next-paragraph-bar') &&
        courseBodyHeight + scrolltop >= maxHeightOfParagraph
      ) {
        paragraphs.forEach((itm) => (itm.state = 'completed'));
      } else {
        const currentParagraph = m_paragraphs.find(
          (itm) =>
            itm.start - courseBodyHeight / 2 <= scrolltop &&
            itm.end - courseBodyHeight / 2 > scrolltop
        );
        const activeParagraphIndex = m_paragraphs.indexOf(currentParagraph);
        setActiveParagraph(activeParagraphIndex);
        if (paragraphs[activeParagraphIndex]?.state === 'not-start') {
          paragraphs[activeParagraphIndex].state = 'in-progress';
        }
        if (
          activeParagraphIndex > 0 &&
          paragraphs[activeParagraphIndex - 1] &&
          paragraphs[activeParagraphIndex - 1]?.state !== 'completed'
        ) {
          paragraphs[activeParagraphIndex - 1].state = 'completed';
        }
      }
      setParagraphState(p_course, p_topic, paragraphs);
    };
    const _onScroll = debounce(onScroll, 100);
    const courseBodyContentHeight =
      document.querySelector<HTMLElement>('.course-body-content')
        ?.offsetHeight || 0;
    const paragraphs = getParagraphState(p_course, p_topic);
    if (
      courseBodyContentHeight <= window.innerHeight &&
      paragraphs.length > 0
    ) {
      paragraphs[0].state = 'completed';
      setParagraphState(p_course, p_topic, paragraphs);
    }
    // clean up code
    document
      ?.querySelector('.course-body')
      ?.removeEventListener('scroll', _onScroll);
    document
      ?.querySelector('.course-body')
      ?.addEventListener('scroll', _onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', _onScroll);
      document
        ?.querySelector('.course-body')
        ?.removeEventListener('scroll', _onScroll);
    };
  }, []);
  return (
    <div className={`course-body-content ${props.className}`}>
      {props.children}
    </div>
  );
};

export default TopicContainer;
